<template>
    <div class="team-content">        
        <div :class="props.isTeamLead ? 'lead' : 'member'">{{ props.member.fullName }}</div>        
        <div class="email">{{props.member.email != props.member.fullName ? props.member.email : ""}}</div>
        <div>
            <DxButton hint="Remove from team" icon="trash" styling-mode="contained" type="normal" @click="removeMember" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { UserItem } from '@/services/entities/UserItem';
import { DxButton } from 'devextreme-vue';

const props = defineProps({
    member: { Type: {} as UserItem, default: {} as UserItem },
    isTeamLead: { type: Boolean, default: false },
});

const emit = defineEmits(["remove"]);

function removeMember() {
    emit("remove", props.member);
}
</script>
<style lang="scss" scoped>
.team-content {
    font-size: normal;
    font-weight: 100;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
}
.lead {
    width: 50%;
    display: block;
    text-align: left;   font-weight: 500;    
}
.member {
    font-weight: 333;
    width: 50%;
    display: block;
    text-align: left;
}
.email {
    font-style: italic;
    color: gray;
    text-align: left;
    width: 50%;
    display: block;
}
</style>